<template>
  <table ref='detailsTable' class="details-content-table">
    <tr v-if="project.uxd.detailsheader == 1 && project.hotspotFuncs.length > 0" class="details-header-row">
      <td style="width:45px"></td>
      <td>
        <table style="width:100%" id="detailsHeaderTable">
          <tr>
            <td v-bind:key="dt.index" v-for="dt in detailsHeader()" class="theme-fontname" :colspan="dt.span" :style="'width:' + (dt.width ? dt.width : 'auto')">
              {{dt.name}}
            </td>
          </tr>
        </table>
      </td>

    </tr>
      <tr v-bind:key="func.index" v-for="func in getFuncs()" class="details-table-row-complete" :id="'dtid' + func.id">
          <td style="width: 45px;" @click="addToCartDT(func)">
            <div v-if="project.uxd.customordericon == '1'" class="bottom-details-view-shop-container-custom" :title="displayScriptMouseover(func)">
              <img :src="displayCustomIcon(func.linktype)">
              <img src="https://data.spareparts.live/assets/icons/checked.png" v-if="displayScriptExecuted(func)" class="bottom-details-view-script-executed"/>
            </div>
            <div v-else>
              <div v-if="displayIcon(func)" class="bottom-details-view-shop-container theme-tabbackcolor" :title="displayScriptMouseover(func)">
                  <img :src="displayIcon(func)">
                  <img src="https://data.spareparts.live/assets/icons/checked.png" v-if="displayScriptExecuted(func)" class="bottom-details-view-script-executed"/>
              </div>
              <div v-else style="max-height:46px;min-width:52px">
                  <img :src="project.uxd.blankicon">
              </div>
            </div>

          </td>

          <td @click="selectPart(func)" class="details-table-row" >
              <table style="font-size:0.9rem;width:100%;table-layout:fixed" class="theme-fontname theme-fontsize" >
                  <tr class="details-content-row" v-bind:key="row_index"
                      v-for="(row, row_index) in groupColumns(func.details)">
                      <td :colspan="dt.span" :style="'width:' + (dt.width ? dt.width : 'auto') + ';word-break:break-word'"  class="details-content-cell" v-bind:key="dt.index"
                          v-for="dt in row">
                          <div class="details-content-cell-content"
                               :leadingIcon="dt.index === 0 ? displayIcon(func): ''"
                               :style="'justify-content:' + dt.align + ''"
                               v-if="dt.column !== '' || dt.value !== ''"
                               :key="dt.index">
                              <div v-if="dt.type === 0">
                                  <span v-if="dt.header && dt.column !== ''">{{dt.displayName}}:</span>  {{dt.value}}
                              </div>
                              <div v-if="dt.type === 1">
                                <span v-for="(l, index) in dt.links" v-bind:key="index">
                                    <a v-if="l.external === true" :href="replaceCookies(l.value)" :target="l.context" :title="l.purpose">
                                        <img :src="displayHyperlinkIcon(l.id)"/>
                                    </a>
                                    <v-icon v-if="l.external === false && l.book === false"
                                            href="#"
                                            @click="showDrawingById(l.linkto)"
                                            :title="project.drawingMap[l.linkto].name"
                                            :style="'color:' + project.uxd.assylinkcolor">
                                            {{project.uxd.assylink}}
                                    </v-icon>
                                    <v-icon v-if="l.external === false && l.book === true"
                                            href="#"
                                            @click="selectPartById(l.linkto)"
                                            :title="project.parts.find(x => x.id === l.linkto).data.name"
                                            :style="'color:' + project.uxd.ecatlinkcolor">
                                            {{project.uxd.ecatlink}}
                                    </v-icon>
                                </span>
                              </div>
                              <div v-if="dt.type === 2">
                                <div v-if="project.uxd.ondemanddynamicdata == '0'">
                                  <span :class="'dyndata_' + func.id + '_' + dt.index" style="display:none">{{resolveExternalData(func.id, dt)}}</span>
                                </div>
                                <div v-else>
                                  <span :class="'dyndata_' + func.id + '_' + dt.index + ' hyperlink'" @click="resolveExternalData(func.id, dt)">{{ dt.cnname }}</span>
                                </div>
                              </div>
                          </div>
                      </td>
                  </tr>
              </table>
              <v-divider v-if="parentComponent == 'PartsGrid'"/>
          </td>
      </tr>
  </table>
</template>
<script>
    import {mapActions, mapState} from 'vuex';
    import {EventBus} from '../services/event-bus.js';

    export default {
        name: 'DetailsTable',
        computed: {
            ...mapState([
                'project',
                'session'
            ])
        },
        mounted() {
          if (this.$store.getters.selectedHotspotId !== -1) {
            this.scrollToHotspot(this.$store.getters.selectedHotspotId);
          }
          this.selectedHotspotIdUnwatch = this.$store.watch(() => this.$store.getters.selectedHotspotId,
            () => {
              this.scrollToHotspot(this.$store.getters.selectedHotspotId);
          });
          EventBus.$on('refresh-drawing', () => {
            this.$forceUpdate();
          });
        },
        props: ['parentComponent'],
        methods: {
            ...mapActions([
                'showDrawingById',
                'selectPartById',
                'pathGet',
                'addToCart',
                'selectHotspot'
            ]),
            groupColumns(xs) {
              let index = 0;
              for(let dt of xs) {
                dt.displayName = (this.project.hotspotsData.columns !== null && this.project.hotspotsData.columns.hasOwnProperty(dt.column)
                ? this.project.hotspotsData.columns[dt.column] : dt.column);
                dt.index = index++;
              }
              return xs.reduce((rv, x) => {
                    (rv[x['y']] = rv[x['y']] || []).push(x);
                    return rv;
                }, {});
            },
            detailsHeader() {
              let result = [];
              // Find first hotspotsFuncs with details (2024-07-03)
              let details = this.project.hotspotFuncs.find(x => x.details != null).details;
              for(let d of details.filter(o => o.y == 0)) {
                if(d.type == 0) {
                  result.push({index: d.index,
                              name: this.project.hotspotsData.columns !== null && this.project.hotspotsData.columns.hasOwnProperty(d.column) ? this.project.hotspotsData.columns[d.column] : d.column,
                              width: d.width });
                } else if(d.type == 1)
                  result.push({index: d.index, name: '', width: d.width });
                else if(d.type == 2)
                  result.push({index: d.index, name: d.cnname, width: d.width });
              }
              return result;

            },
            getFuncs() {
              if(this.parentComponent == 'DetailsView')
                return this.project.selectedHotspot.func;
              else if(this.parentComponent == 'PartsGrid') {
                let funcs = [];
                for(let h of this.project.hotspotsData.hotspots)
                  for(let f of h.func)
                    funcs.push({hotspotId: h.id, ...f});
                funcs = funcs.reduce((a, b) => {
                  if(!a.find((item) => item.oem === b.oem && item.pos === b.pos))
                    a.push(b);
                  return a;
                }, []);
                return funcs;
              }
              return [];
            },
            addToCartDT(func) {

              if(this.parentComponent == 'PartsGrid')
                this.selectPart(func);

              this.project.orderColumnValue = '';
              this.addToCart(func);
            },

            getBoilerplateIconStyle() {
              return 'display:' + (this.project.uxd.hidecartonnopart == "true" ? 'none' : 'block');
            },
            displayIcon(func) {
              if (func.linktype == "O") return this.project.uxd.shopicon;
              if (func.linktype === 'Q') return this.project.uxd.quoteicon
              return undefined;
            },
            displayIconColor(func) {
                if (func.linktype === 'O') return this.project.uxd.cartcolor
                if (func.linktype === 'Q') return this.project.uxd.infocolor
            },
            displayHyperlinkIcon(id) {
                return this.project.baseurl + 'getLinkIcon.php?token=' + this.project.token + '&id=' + id
            },
            displayScriptExecuted(func) {
              let cookie = func.linktype === 'O' ? 'orderscriptcalls' : 'quotescriptcalls';
              let context = func.linktype === 'O' ? this.project.uxd.ordercontext : this.project.uxd.quotecontext;
              if(context == "_script" || context == "_email") {
                let osc = JSON.parse(sessionStorage.getItem(cookie) || "[]");
                return osc.includes(func.id);
              } else {
                sessionStorage.removeItem(cookie);
                return false;
              }
            },
            displayScriptMouseover(func) {
              let cookie = func.linktype === 'O' ? 'orderscriptcalls' : 'quotescriptcalls';
              let context = func.linktype === 'O' ? this.project.uxd.ordercontext : this.project.uxd.quotecontext;
              let title = func.linktype === 'O' ? this.project.uxd.hovertriggeredorder : this.project.uxd.hovertriggeredquote;
              if(context == "_script" || context == "_email") {
                let osc = JSON.parse(sessionStorage.getItem(cookie) || "[]");
                return osc.includes(func.id) ? title : '';
              } else {
                return '';
              }
            },
            async resolveExternalData(funcid, dt) {
              if(dt.cntype == 'openget') {
                let raw = '';
                let data = '';
                let config = JSON.parse(dt.config);
                let headers = config.authorization == 'none' ? {} : {'Authorization' : 'Basic ' + window.btoa(config.key + ':' + config.secret)};
                if(config.datatype == "text") {
                  await fetch(config.url, {mode: 'cors', method:'GET', headers:headers }).then(x => x.text()).then(x => raw = x);
                  data = raw;
                } else {
                  await fetch(config.url, {mode: 'cors', method:'GET', headers:headers}).then(x => x.json()).then(x => raw = x);
                  if(typeof raw === "string")
                    data = JSON.parse(raw);
                  else
                    data = raw;
                  if(config.property != "")
                    data = this.pathGet(data, config.property, "");
                }
                if(config.format != "" && config.format != "*")
                  data = config.format.replace("*", data);
                let el = document.getElementsByClassName("dyndata_" + funcid + "_" + dt.index)[0];
                el.innerHTML = (dt.header ? (dt.cnname + ": ") : "" )+ data;
                el.style.display = "";
                return '';
              }
              return '';
            },
            pathGet(obj, path, def) {
              let stringToPath = (path) => {
                if (typeof path !== 'string') return path;
                let output = [];
                for(let item of path.split('.')) {
                  for(let key of item.split(/\[([^}]+)\]/g)) {
                    if (key.length > 0) {
                      output.push(key);
                    }
                  }
                }
                return output;
              };
              path = stringToPath(path);
              let current = obj;
              for (let i = 0; i < path.length; i++) {
                if (!current[path[i]]) return def;
                current = current[path[i]];
              }
              return current;
            },
            displayCustomIcon(linkType) {
              if(linkType == "O") {
                if(this.project.uxd.customordericon == "0") return undefined;
                return "https://data.spareparts.live/assets/styles/cta_order_" + this.project.uxd.domainid + ".png?" + new Date().getTime();
              } else if(linkType == "Q") {
                if(this.project.uxd.customquoteicon == "0") return undefined;
                return "https://data.spareparts.live/assets/styles/cta_quote_" + this.project.uxd.domainid + ".png?" + new Date().getTime();
              }
              else return undefined;
            },
            selectPart(func) {
              if(this.parentComponent != 'PartsGrid') return;
              this.$store.commit('updatePanAndZoomOnHotspotSelection', true);
              this.selectHotspot({hotspotId: func.hotspotId, specificFunc: func.id});
              this.highlightDetailsRows(["dtid" + func.id]);
            },
            scrollToHotspot(id) {
              if(this.parentComponent != 'PartsGrid' || this.project.specificFunc != -1) return;
              let selFunc = this.project.hotspotFuncs.filter(x => x.hotspotId == id).map(x => "dtid" + x.id);
              if(selFunc.length > 0 ) {
                let item = document.getElementById(selFunc[0]);
                if(item) {
                  let prevItem = item.previousSibling;
                  if(prevItem)
                    prevItem.scrollIntoView({behavior: "smooth"});
                  else
                    document.querySelector(".details-content-table").scroll({top:0, behavior:'smooth'});
                }
              }
              this.highlightDetailsRows(selFunc);
            },
            highlightDetailsRows(selFunc) {
              for(let el of document.querySelectorAll(".details-table-row-complete")) {
                  let table = el.querySelector(".details-table-row");
                  if(selFunc.includes(el.id))
                    table.classList.add("theme-highlightcolor");
                  else
                    table.classList.remove("theme-highlightcolor");
                }
            },
            replaceCookies(url) {
              while (url.includes('{cookie:')) {
                let p1 = url.indexOf('{cookie:')
                let p2 = url.indexOf('}', p1);
                if(p2 > p1 && p1 > -1) {
                  let name = url.slice(p1 + 8, p2);
                  let value = window.sessionStorage.getItem('uc_' + name) ?? '';
                  url = url.slice(0, p1) + value + url.slice(p2 + 1);
                } else {
                  break;
                }
              }
              return url;
            }
          }
        }
</script>
